import React from 'react';

export default function Sandbox({ children }: { name: string; children?: any }){
  return <>{children}</>;
}
